<template>
  <div class="card-body pt-2 pb-0 px-2">
    <div class="feedpost-head">
      <div class="feedpost-user mr-2">
        <a href="javascript:void(0);" @click="person(item)">
          <img
            class="user-logo mr-2"
            :src="item.userLogoBig"
            :onerror="$defaultUserLog"
        /></a>
        <span class="feedpost-username">
          <a href="javascript:void(0);" @click="person(item)">
            {{
              item.sgL_MyVideoName ? item.sgL_UsersName + '('+ item.sgL_MyVideoName + ')' : item.sgL_UsersName
            }}
          </a></span
        >
        <span class="publish-time">{{ item.sgL_PG_CAddTimerI }}</span>
      </div>
      <div class="feedpost-more">
        <i class="fa fa-ellipsis-h"></i>
        <div class="feedpost-menus">
          <a href="javascript:void(0);" @click="collectFunc(item)">
            <li class="bookmark">
              <i class="fas fa-bookmark fa-fw" v-if="item.sgL_IsFavorite"></i>
              <i v-else class="far fa-bookmark mr-1"></i>  {{ $t('Social.DataView.bookmark') }}
            </li>
          </a>
          <a href="javascript:void(0);" @click="reportFunc(item)">
            <li class="report">
              <i v-if="item.sgL_IsImpeach" class="fa fa-flag mr-1"></i>
              <i v-else class="far fa-flag mr-1"></i>  {{ $t('Social.DataView.flag') }}
            </li>
          </a>
          <a
            href="javascript:void(0);"
            @click="deleteFunc(item)"
            v-if="customer != null && item.sgL_UserID == customer.userId"
          >
            <li class="delete">
              <i class="far fa-trash-alt mr-1"></i>
               {{ $t('Social.DataView.delbolg') }}
            </li>
          </a>
        </div>
      </div>
    </div>
    <div class="feedpost-content2">
      <p class="content">{{ item.sgL_Content }}</p>
      <a href="javascript:void(0);" @click="viewInfo(item)">
        <img
          class="feedImg"
          v-if="item.sgL_Type == 1 && !IsNullOrEmpty(item.sgL_ImageTempURL)"
          :src="item.sgL_ImageTempURL"
        />
      </a>
      <video-player v-watermark
        v-if=" 
          item.sgL_Type == 0 &&
          item.fileShareUrl != null &&
          item.fileShareUrl != ''
        "
        class="video-player vjs-custom-skin"
        :playsinline="true"
        :options="playerOptions"
        @play="onPlayerPlay($event, item.id)"
      ></video-player>
    </div>
    <ul class="feedpost-action">
      <a href="javascript:void(0);" @click="likeFunc(item, item.sgL_IsLike)">
        <li class="like" v-if="item.sgL_IsLike">
          <i class="fas fa-thumbs-up mr-1" v-if="item.sgL_PG_CTotalLike == 0">
             {{ $t('Social.DataView.thumbs') }}</i
          >
          <i class="fas fa-thumbs-up mr-1" v-else>
            {{ item.sgL_PG_CTotalLike }}</i
          >
        </li>
        <li class="like" v-else>
          <i class="far fa-thumbs-up mr-1" v-if="item.sgL_PG_CTotalLike == 0">
             {{ $t('Social.DataView.thumbs') }}</i
          >
          <i class="far fa-thumbs-up mr-1" v-else>
            {{ item.sgL_PG_CTotalLike }}</i
          >
        </li>
      </a>
      <a href="javascript:void(0);" @click="commentShow(item)">
        <li class="comment">
          <i class="far fa-comment mr-1" v-if="item.sgL_PG_CTotalMesg == 0">
             {{ $t('Social.DataView.comment') }}</i
          >
          <i class="far fa-comment mr-1" v-else>
            {{ item.sgL_PG_CTotalMesg }}</i
          >
        </li>
      </a>
      <a
        href="javascript:void(0);"
        style="color: #292c32"
        @click="updateStatistics(item, 50)"
      >
        <li class="share right">
          <i v-if="item.sgL_PG_CTotalShare == 0" class="fa fa-share mr-1">
             {{ $t('Social.DataView.share') }}</i
          >

          <i v-else class="fa fa-share mr-1"> {{ item.sgL_PG_CTotalShare }}</i>
        </li>
      </a>
    </ul>
    <transition name="el-fade-in-linear">
      <div class="feedpost-comment" v-show="commentShowId == item.id">
        <input
          class="form-control form-control-sm"
          type="text"
          :placeholder="$t('Social.DataView.placeholder') "
          v-model="commentText"
          @keydown="key($event, item)"
        />
        <div class="feedpost-comment-list">
          <div class="comment" v-for="(comment,idx) in commentList" :key="idx">
            <div class="comment-left mr-2">
              <a href="javascript:void(0);">
                <img
                  class="user-logo"
                  :src="comment.sgL_ImageLogin"
                  alt="user-icon"
                  :onerror="$defaultUserLog"
                />
              </a>
            </div>
            <div class="comment-right" style="flex: 1">
              <span class="feedpost-username">
                <a href="javascript:void(0);">
                  <!-- {{ comment.sgL_Mem_DisplayName }} -->
                  <router-link :to="{name:'customerPublishLook',query: { 'authorId': comment.sgL_Mem_Cid } }">
          {{ comment.sgL_Mem_DisplayName }}
        </router-link>
                </a></span
              >
              <span class="publish-time">
                {{ comment.sgL_Msg_MAddTimerI }}
              </span>
              <span class="comment-content">
                {{ comment.sgL_Msg_MContent }}
                <a
                  href="javascript:"
                  style="font-size: 12px"
                  @click="commentShowIds = comment.id"
                  > {{ $t('Social.DisplayVideo.recover') }}</a
                >
                <deleteCommentVue
                  style="font-size: 12px"
                  :commentId="comment.id"
                  :authId="comment.sgL_Mem_Cid"
                  @delSuccess="$emit('getComments')"
                ></deleteCommentVue>
              </span>
              <div v-show="commentShowIds === comment.id">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  :placeholder="$t('Social.DisplayVideo.placeholder2')"
                  v-model="commentText2"
                  @keydown="key2($event, item, comment)"
                />
              </div>
              <div
                v-for="(comments,idx) in comment.messageDto"
                style="margin-top: 10px"
              :key="idx">
                <div style="display: flex">
                  <a href="javascript:void(0);">
                    <img
                      class="user-logo"
                      :src="comments.sgL_ImageLogin"
                      alt="user-icon"
                      :onerror="$defaultUserLog"
                    />
                  </a>
                  <div
                    style="flex: 1;display: flex;flex-direction: column;margin-left: 5px;">
                    <div>
                      <span class="feedpost-username">
                        <!-- <a href="javascript:void(0);">
                          {{ comments.sgL_Mem_DisplayName }}
                        </a> -->
                        <router-link :to="{name:'customerPublishLook',query: { 'authorId': comments.sgL_Mem_Cid } }">
                          {{ comments.sgL_Mem_DisplayName }}
                        </router-link>
                        </span
                      >
                    </div>
                    <div>
                      <span class="publish-time">
                        {{ comments.sgL_Msg_MAddTimerI }}
                      </span>
                    </div>
                    <div>
                      <span class="comment-content">
                        {{ comments.sgL_Msg_MContent }}
                        <deleteCommentVue
                          style="font-size: 12px"
                          :commentId="comments.id"
                          :authId="comments.sgL_Mem_Cid"
                          @delSuccess="$emit('getComments')"
                        ></deleteCommentVue>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import deleteCommentVue from "../common/deleteComment.vue";
import watermark from 'watermark-dom'
export default {
  components: {
    deleteCommentVue,
  },
  data() {
    return {
      customer: null,
      commentList: null,
      commentText: "",
      commentText2: "",
      commentShowId: -1,
      isCanEntry: false,
      isCanEntry2: false,
      commentShowIds: -1,
    };
  },
  created() {
    this.customer = this.$store.getters.getcustomer;
  },
  props: {
    item: { Type: Object },
    playerOptions: { Type: Object },
    shareurl: { Type: String },
  },
  methods: {
    person(item) {
      // this.$router.push({
      //   name: "FeedPerson",
      //   query: { uid: item.sgL_UserID },
      // });
      this.$router.push({
        name: "customerPublishLook",
        query: { authorId: item.sgL_UserID },
      });
    },
    collectFunc(item) {
      this.$emit("collectFunc", item);
    },
    reportFunc(item) {
      this.$emit("reportFunc", item);
    },
    deleteFunc(item) {
      this.$emit("deleteFunc", item);
    },
    onPlayerPlay(data1, data2) {
      this.$emit("onPlayerPlay", data1, data2);
    },
    likeFunc(item, isadd) {
      this.$emit("likeFunc", item, isadd);
    },
    commentShow(item) {
      if (this.commentShowId == item.id) {
        this.commentShowId = -1;
        return;
      }
      this.commentText = "";
      this.commentText2 = "";
      this.commentList = null;
      this.$emit("commentShow", item);
    },
    setCommentData(data) {
      this.commentText = "";
      this.commentText2 = "";
      this.commentShowId = this.item.id;
      this.commentList = data;
      this.item.sgL_PG_CTotalMesg = data.length;
      this.isCanEntry = false;
      this.isCanEntry2 = false;
    },
    key(event, item) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13 && !this.isCanEntry) {
        this.isCanEntry = true;
        this.$emit("submitComment", item, this.commentText, true);
      }
    },
    key2(event, item, comment) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13 && !this.isCanEntry2) {
        this.isCanEntry2 = true;
        this.$emit(
          "submitComment2",
          item,
          //event.target.value,
          this.commentText2,
          null,
          this.commentShowIds,
          comment.sgL_Mem_Reply_Cid
        );
      }
    },
    updateStatistics(item, type) {
      this.$emit("updateStatistics", item, type);
    },
    viewInfo(item) {
      this.$emit("viewInfo", item);
    },
  },
  mounted(){

  },
};
</script>

<style scoped>
.feedpost-comment {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  display: block;
}
.content {
  margin: 10px;
}
.feedImg {
  /* max-width: 420px; */
  max-height: 315px;
  margin: 5px 5px 5px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/FeedCard.vue